export default "/images/6737ef5cd903552846b749af4cdba393.avif";